import kanbanAPI from 'dashboard/api/kanban';

export default {
  data() {
    return {
      _lastColMoveAt: 0,
    };
  },
  methods: {
    isVirtual(col) {
      return typeof col?.id !== 'number' || col?.virtual === true;
    },
    realColumns() {
      return (this.board?.columns || []).filter(c => !this.isVirtual(c));
    },

    async onColumnChange(evt) {
      try {
        if (!evt?.moved) return;

        const now = Date.now();
        if (now - this._lastColMoveAt < 150) return; // evita duplicação
        this._lastColMoveAt = now;

        const col = evt.moved.element;
        if (this.isVirtual(col) || typeof col.id !== 'number') return;

        const reals = this.realColumns();
        const to = reals.findIndex(c => c.id === col.id);
        if (to < 0) return;

        await kanbanAPI.moveColumn(col.id, {
          target_position: to,
        });
      } catch (e) {
        this.error = e?.response?.data?.error || e.message || 'Falha ao mover coluna';
      } finally {
        this.deferUpdateHeights?.();
      }
    },

    // fallback discreto (chama só se não houve onColumnChange “recente”)
    async onColumnEnd(evt) {
      try {
        if (!evt || evt.oldIndex == null || evt.newIndex == null) return;
        const now = Date.now();
        if (now - this._lastColMoveAt < 150) return; // já tratamos no onChange

        const movedCol = this.board?.columns?.[evt.newIndex];
        if (!movedCol || this.isVirtual(movedCol) || typeof movedCol.id !== 'number') return;

        const reals = this.realColumns();
        const to = reals.findIndex(c => c.id === movedCol.id);
        if (to < 0) return;

        await kanbanAPI.moveColumn(movedCol.id, {
          target_position: to,
        });
      } catch (e) {
        this.error = e?.response?.data?.error || e.message || 'Falha ao mover coluna';
      } finally {
        this.deferUpdateHeights?.();
      }
    },
  },
};
